import { Cookies } from 'quasar'
import { configurationCookiesConfig, setUssidToCookies } from 'src/common/functions'
import { CONFIG } from 'src/common/config'

export class TokenService {
  constructor() {
    this.cookieKey = process.env.TOKEN_KEY
  }
  setToken(token, ussid) {
    const configCookies = configurationCookiesConfig(token, CONFIG.COOKIES_OPTIONS)
    Cookies.set(this.cookieKey, token, configCookies)
    if (ussid) {
      setUssidToCookies(ussid, configCookies.expires)
    }
  }
  getToken() {
    return Cookies.get(this.cookieKey)
  }
  removeToken() {
    Cookies.remove('ussid', CONFIG.COOKIES_OPTIONS_REMOVE)
    Cookies.remove('ssid', CONFIG.COOKIES_OPTIONS_REMOVE)
    Cookies.remove(this.cookieKey, CONFIG.COOKIES_OPTIONS_REMOVE)
  }
}
